module.exports = __webpack_public_path__ + "static/media/logo_menu_black.08794bb2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_menu_black.png
// module id = 27
// module chunks = 0